import { MOBILE_ALERT_TYPE } from './constants';

export const MOBILE_ALERT_DATA = {
  [MOBILE_ALERT_TYPE.first]: {
    days: 14,
  },
  [MOBILE_ALERT_TYPE.second]: {
    days: 90,
  },
};

export default {
  MOBILE_ALERT_DATA,
};
